import { useState } from 'react';

import clsx from 'clsx';

import { IM20CategoriesModule } from '~/lib/data-contract';
import { AnimatedAutoHeight } from '~/shared/components/AnimatedAutoHeight/AnimatedAutoHeight';
import { Button } from '~/shared/components/Button/Button';
import { Headline } from '~/shared/components/Headline/Headline';
import { useTranslation } from '~/shared/utils/translation/hooks/useTranslation';
import { ModuleContainer } from '~/templates/blocks/components/ModuleContainer/ModuleContainer';

import { M21ListItem } from './components/M21ListItem/M21ListItem';
import styles from './m21Categories.module.css';

export type M21CategoriesProps = IM20CategoriesModule & {
	hideHeadline?: boolean;
};

export const M21Categories = ({ id, headline, hideHeadline, items, anchorId }: M21CategoriesProps) => {
	const { translate } = useTranslation();
	const [open, setOpen] = useState(false);

	const handleClick = () => setOpen((prevOpen) => !prevOpen);

	return (
		<ModuleContainer
			className={styles.root}
			id={id}
			anchorId={anchorId?.toLowerCase()}
		>
			{headline && !hideHeadline ? (
				<Headline
					className={styles.headline}
					size={3}
				>
					{headline.text}
				</Headline>
			) : null}
			<AnimatedAutoHeight>
				<ul className={clsx(styles.list, open && styles.open)}>
					{items.map((item) => (
						<M21ListItem {...item} />
					))}
				</ul>
				<div className={styles.footer}>
					<hr className={styles.line} />
					<Button
						variant="outline"
						onClick={handleClick}
					>
						{open
							? translate('categories-with-images.see-less')
							: translate('categories-with-images.see-more', {
									count: items.length,
							  })}
					</Button>
					<hr className={styles.line} />
				</div>
			</AnimatedAutoHeight>
		</ModuleContainer>
	);
};
